<template>
  <fragment>
    <h2 class="pt-0 pb-3 lightblue--text">{{ nameForm }}</h2>
    <v-layout row wrap v-if="delegate.proposta.restituicao">
      <v-flex xs7>
        <v-label>Valor a ser restituído </v-label>
        <v-text-field class="jns-input" disabled :value="valueRefund" />
      </v-flex>
    </v-layout>
    <v-layout row wrap v-else>
      <v-flex xs7>
        <v-label>Valor do prêmio (Mínimo {{ minPremium }}) </v-label>
        <v-text-field class="jns-input" disabled :value="formattedPremium" />
      </v-flex>
      <v-flex xs5>
        <v-label>Taxa aplicada</v-label>
        <v-icon
          class="icon_blue lightblue--text"
          @mouseover="delegate.showTooltipTax = true"
          @mouseleave="delegate.showTooltipTax = false"
        >
          help
        </v-icon>
        <div
          class="msg-frame msg-tax"
          style="text-align: justify"
          v-if="delegate.showTooltipTax"
        >
          <p>
            A taxa é o índice que determina a precificação do prêmio do seguro.
          </p>
          <br />
          <p>
            O valor do prêmio é calculado levando-se em conta a seguinte
            fórmula.
          </p>
          <br />
          <p>
            Valor do Prêmio = (Valor da Importância Segurada * (Taxa / 100) *
            Nro. Dias Vigência Proposta) / 365
          </p>
          <br />
          <p>
            São consideradas para a composição da taxa (e por consequência do
            prêmio) diversos fatores como: o risco inerente ao negócio, a
            comissão a ser paga e também a remuneração da seguradora. Por isso,
            qualquer alteração agravamento em valor do prêmio ou dos percentuais
            de comissão, geram alteração da taxa.
          </p>
          <br />
          <p>
            A taxa original apresentada é a menor taxa praticada pela seguradora
            para este risco.
          </p>
          <br />
          <p>
            Qualquer redução abaixo do valor original, será realizada
            reduzindo-se exclusivamente o percentual de comissão
          </p>
        </div>
        <v-text-field
          class="jns-input"
          :value="`${delegate.proposta.taxa}%`"
          disabled
          @focus="delegate.isInputTaxa = true"
          @blur="updateAppliedTaxes"
        />
        <span class="hint">Original {{ delegate.Txo }}%</span>
      </v-flex>
      <v-flex xs7>
        <v-label>Valor da Comissão</v-label>
        <v-text-field
          class="jns-input"
          disabled
          :value="formattedComission"
          @focus="delegate.isInputCommissionActive = true"
          @blur="updateCommission"
        />
      </v-flex>
      <v-flex xs5>
        <v-label>% de comissão</v-label>
        <v-icon
          class="icon_blue lightblue--text"
          @mouseover="delegate.showTooltipCommission = true"
          @mouseleave="delegate.showTooltipCommission = false"
          :disabled="!delegate.permissao_alterar_portal"
        >
          help
        </v-icon>
        <div
          class="msg-frame msg-commission"
          style="text-align: justify"
          v-if="delegate.showTooltipCommission"
        >
          <p>
            Por padrão, nosso sistema sempre aplica o maior percentual de
            comissão possível no cálculo da apólice.
          </p>
          <br />
          <p>
            Entretanto, caso o corretor opte por uma diminuição do % da sua
            comissão em um determinado negócio, ele pode alterar diretamente
            neste campo.
          </p>
          <br />
          <p>
            Uma vez alterado o % de comissão para um valor abaixo do máximo
            permitido, o ícone do cadeado ficará fechado indicando que o
            percentual não irá variar conforme a taxa seja alterada para cima. O
            cadeado pode ser aberto e a comissão alterada novamente com um
            simples clique.
          </p>
          <br />
          <p>
            Ao acessar o passo 5, o percentual padrão de comissão do sistema é
            aplicado.
          </p>
          <br />
          <p>
            Para tomadores com acumulo abaixo de R$ 1,5 milhões (soma de todas
            as importâncias seguradas ativas já permitidas), o % de comissão
            será agravado a medida que a taxa for também agravada na seguinte
            proporção: Para cada +0,1% na taxa, a comissão é agravada em 0,5%. O
            % máximo de comissão possível é de 41%.
          </p>
          <br />
          <p>
            Em tomadores com acumulo acima de R$ 1,5 milhões, o % máxima será o
            percentual padrão do sistema, não aumentando a medida que a taxa é
            agravada.
          </p>
          <br />
          <p>
            Entretanto, mesmo não sendo possível o aumento do % de comissão, o
            valor absoluto da comissão aumenta a medida que a taxa é agravada.
          </p>
        </div>
        <v-text-field
          :value="`${delegate.proposta.comissao_percentual}%`"
          class="jns-input read_only"
          readonly
          :append-icon="delegate.lock_icon"
          disabled
        />
        <span class="hint">Máximo {{ delegate.Ccmax }}%</span>
      </v-flex>
    </v-layout>
  </fragment>
</template>

<script lang="js">
import { toMoneyString } from "@/libs/utils";

export default {
  name: "PremioComissaoForm",
  props: ["delegate"],
  computed: {
    nameForm() {
      return this.delegate.proposta.restituicao ? "Restituição" : "Prêmio e Comissão";
    },
    disableCommission() {
      const { slider, permissao_alterar_portal } = this.delegate;
      return slider.limitType == '%' || !permissao_alterar_portal;
    },
    disableAppliedTaxes() {
      const { slider, permissao_alterar_portal } = this.delegate;
      return slider.limitType == '$' || !permissao_alterar_portal
    },
    minPremium() {
      return toMoneyString(this.delegate?.proposta?.premio_minimo);
    },
    formattedComission() {
      return toMoneyString(this.delegate?.proposta?.comissao_reais);
    },
    valueRefund() {
      return toMoneyString(this.delegate?.proposta?.premio);
    },
    formattedPremium() {
      return toMoneyString(this.delegate?.proposta?.premio);
    }
  },
  methods: {
    updateCommission() {
      this.delegate.isInputCommissionActive = false;
      this.delegate.atualiza_valores_pelo_campo_da_comissao();
    },
    updateAppliedTaxes() {
      this.delegate.isInputTaxa = false;
      this.delegate.atualiza_valores_pelo_campo_da_taxa();
    }
  }
};
</script>

<style lang="scss" scoped>
#jns {
  .v-icon {
    font-size: 20px !important;
  }

  .icon_blue {
    cursor: help;
  }

  .msg-frame {
    position: absolute;
    padding: 12px;
    left: 40%;
    top: 8%;
    border-radius: 4px;
    font-size: 13px;
    color: black;
    background-color: #fff;
    box-shadow: 0 0 1em #ccc;
    z-index: 999;

    p {
      text-align: left;
      margin-bottom: 0;
      font-weight: normal;
    }
  }

  .msg-tax {
    width: 42%;
  }

  .msg-commission {
    width: 50%;
  }

  .hint {
    float: right;
    margin-top: -16px;
    font-size: 10px;
  }

  .v-responsive {
    flex: inherit !important;
  }

  .read_only {
    background-color: #e6e6e6;
    height: 45px;
    padding-top: 0px;
    margin-top: 16px;
    padding-bottom: 10px;
    margin-bottom: 20px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/Apolice/Steps/PremioComissaoForm.vue